// extracted by mini-css-extract-plugin
export default {"conPrin":"Landing_conPrin__hJt3y","homepage":"Landing_homepage__8fpt7","boton":"Landing_boton__JmNdJ"};